import { render, staticRenderFns } from "./productContainer.vue?vue&type=template&id=34599c82&scoped=true"
import script from "./productContainer.vue?vue&type=script&lang=js"
export * from "./productContainer.vue?vue&type=script&lang=js"
import style0 from "./productContainer.vue?vue&type=style&index=0&id=34599c82&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34599c82",
  null
  
)

export default component.exports